import { sortCities } from "./sortCities.js";
function getCitiesByCluster(cities) {
  const citiesByCluster = /* @__PURE__ */ new Map();
  cities.forEach((city) => {
    var _a;
    const clusterName = ((_a = city.cluster) == null ? void 0 : _a.name) || null;
    const clusterCities = citiesByCluster.get(clusterName ?? null) ?? [];
    clusterCities.push(city);
    citiesByCluster.set(clusterName, clusterCities);
  });
  citiesByCluster.forEach((cities2) => {
    cities2.sort(sortCities);
    const mainInCluster = cities2.find((city) => city.isMainInCluster);
    const restCities = cities2.filter((city) => !city.isMainInCluster);
    if (mainInCluster) {
      restCities.splice(0, 0, mainInCluster);
    }
    cities2.splice(0, cities2.length, ...restCities);
  });
  const orderedCities = Array.from(citiesByCluster.values());
  orderedCities.sort((clusterA, clusterB) => {
    var _a, _b, _c, _d;
    const clusterAItem = clusterA[0];
    const clusterBItem = clusterB[0];
    const positionA = (_a = clusterAItem.cluster) == null ? void 0 : _a.position;
    const positionB = (_b = clusterBItem.cluster) == null ? void 0 : _b.position;
    const clusterAName = (_c = clusterAItem.cluster) == null ? void 0 : _c.name;
    const clusterBName = (_d = clusterBItem.cluster) == null ? void 0 : _d.name;
    if (positionA !== void 0 && positionB !== void 0) {
      if (positionA === positionB) {
        if (clusterAName && clusterBName) {
          return clusterAName.localeCompare(clusterBName);
        }
      }
      return positionA - positionB;
    }
    if (clusterAName && clusterBName) {
      return clusterAName.localeCompare(clusterBName);
    }
    return 1;
  });
  return citiesByCluster;
}
export {
  getCitiesByCluster
};
